module.exports = __webpack_public_path__ + "img/dialog-title-jpmx.3fc2c6c4.png";